import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { Check } from 'phosphor-react';

interface StepIndicatorProps {
  currentStep: number;
  // Títulos dos passos (constituição: fieldGroups; Baixa: vêm do back, por etapa).
  titulos: string[];
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, titulos }) => {
  return (
    <Flex align="center" gap={2} w="full" maxW="600px" mx="auto" mb={6}>
      {titulos.map((titulo, idx) => {
        const step = idx + 1;
        const isDone = step < currentStep;
        const isCurrent = step === currentStep;
        const isUpcoming = step > currentStep;

        return (
          <React.Fragment key={titulo}>
            <Flex direction="column" align="center" gap={1.5} flex="0 0 auto">
              <Flex
                w="32px"
                h="32px"
                borderRadius="full"
                align="center"
                justify="center"
                bg={(() => {
                  if (isCurrent) return 'blue.500';
                  if (isDone) return 'green.500';
                  return 'gray.200';
                })()}
                color={isUpcoming ? 'gray.500' : 'white'}
                fontWeight="700"
                fontSize="sm"
                transition="all 0.2s ease"
              >
                {isDone ? <Check size={16} weight="bold" /> : step}
              </Flex>
              <Text
                fontSize="11px"
                fontWeight={isCurrent ? '700' : '500'}
                color={isCurrent ? 'gray.800' : 'gray.500'}
                textAlign="center"
                maxW="100px"
                lineHeight="1.2"
              >
                {titulo}
              </Text>
            </Flex>
            {idx < titulos.length - 1 && (
              <Box flex="1" h="2px" bg={step < currentStep ? 'green.400' : 'gray.200'} mt="-18px" />
            )}
          </React.Fragment>
        );
      })}
    </Flex>
  );
};
